// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  variantId: __t.u64().primaryKey().name("variant_id"),
  renderAssetId: __t.u64().name("render_asset_id"),
  lod: __t.u8(),
  uri: __t.string(),
  polyCount: __t.u32().name("poly_count"),
  screenSizeThreshold: __t.f32().name("screen_size_threshold"),
});
